import { RegistrationControllerApiFactory } from '@api-client'
import logoImage from '@assets/images/co2ai-logo.png'
import { Loading } from '@components/Loading'
import { useAsyncApi } from '@hooks/useAsyncApi'
import { Grid, Link, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import * as S from './styles'

export enum UserAccessActionType {
	APPROVE_ACCESS = 'approveAccess',
	DENY_ACCESS = 'denyAccess',
}

export interface UserAccessActionProps {
	actionType: UserAccessActionType
}

const UserAccessAction = ({ actionType }: UserAccessActionProps) => {
	const registrationControllerApi = useAsyncApi(
		RegistrationControllerApiFactory
	)
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const [token] = useState(searchParams.get('token') || '')
	const [error, setError] = useState<Error>()
	const [isLoading, setIsLoading] = useState<boolean>()

	useEffect(() => {
		async function approveOrDeny(): Promise<void> {
			try {
				setIsLoading(true)
				if (token) {
					if (actionType === UserAccessActionType.APPROVE_ACCESS) {
						await registrationControllerApi(Api =>
							Api.approveUserAccessRequest(token)
						)
					} else {
						await registrationControllerApi(Api =>
							Api.denyUserAccessRequest(token)
						)
					}
				} else {
					navigate('/login')
				}
			} catch (error: unknown) {
				setError(error as Error)
			} finally {
				setIsLoading(false)
			}
		}
		approveOrDeny()
	}, [actionType, navigate, registrationControllerApi, token])

	const { t } = useTranslation()

	return (
		<Grid
			container
			direction="row"
			justifyContent="center"
			mt={10}
			width="100%"
		>
			<Grid size={{ xs: 10, sm: 6, md: 5, lg: 3 }}>
				<S.Logo src={logoImage} />
				{isLoading ? (
					<Loading />
				) : error ? (
					<Typography variant="h6" component="h2" marginTop={4}>
						{t('errorTryAgain')}
					</Typography>
				) : (
					<Typography variant="h6" component="h2" marginTop={4}>
						{actionType === UserAccessActionType.APPROVE_ACCESS
							? t('approveUserAccess')
							: t('denyUserAccess')}
					</Typography>
				)}
				<Link href="/">{t('backToHomePage')}</Link>
			</Grid>
		</Grid>
	)
}

export { UserAccessAction }
